import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import { Card, CardBody, CardTitle } from 'reactstrap';
import {
  searchMarigrams as searchMarigramsAc,
  clearRedirect as clearRedirectAc,
  clearMarigramSearch as clearMarigramSearchAc,
} from '../../../../../../redux/tsunamis/marigrams/search/marigramSearchActions';
import {
  deleteMarigram as deleteMarigramAc,
  getCountries as getCountriesAc,
  getLocations as getLocationsAc,
  getStates as getStatesAc,
  clearMarigramData as clearMarigramDataAc,
  sortData as sortDataAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../../../redux/tsunamis/marigrams/data/marigramDataActions';
import { isDataManager } from '../../../../../../role/roleUtils';
import { SearchParamDisplay } from '../../../../../data/SearchParamDisplay';
import { resolveSearchParameters } from '../search/marigramSearchParameterNameResolver';
import { Loading } from '../../../../../loadbar/Loading';
import { MarigramDataGrid } from './MarigramDataGrid';

class MarigramContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.toggleDescriptionModal = this.toggleDescriptionModal.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.state = {
      queryParameters: {},
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Marigram Results';
    const {
      clearMarigramData,
      getCountries,
      getLocations,
      getStates,
      searchMarigrams,
      clearRedirect,
      searchRedirect,
      location: { search },
      history,
    } = this.props;
    clearMarigramData();
    getCountries({ history });
    getLocations({ history });
    getStates({ history });
    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }
    if (!searchRedirect) {
      searchMarigrams({ queryParameters, history });
    } else {
      clearRedirect();
    }
    this.setState({ queryParameters });
  }

  componentWillUnmount() {
    const { clearMarigramSearch, clearMarigramData } = this.props;
    clearMarigramSearch();
    clearMarigramData();
  }

  toggleDescriptionModal(name) {
    this.setState(state => ({ modals: state.modals.update(name, val => !val) }));
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  render() {
    const {
      marigrams,
      fetched,
      deleting,
      authorities,
      countries,
      locations,
      states,
      sort,
      visibleColumns,
      history,
      deleteMarigram,
      searchMarigrams,
    } = this.props;
    const { queryParameters } = this.state;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters,
      countries,
      locations,
      states,
    });

    return (
      <div className="haz-results-container haz-page-container">
        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <div className="haz-data-grid-container">
            <Card>
              <CardBody>

                <div className="doiCitation">
                  <span id="doiReference">
                    <p>
                      Please cite individual marigrams. For marigrams that do not have a DOI, please cite as:
                      <br />
                      <b>
                        NOAA National Centers for Environmental Information; NCEI: Archival and Discovery of [event YYYY-MM-DD] Tsunami Event on Marigrams. NOAA National Centers for Environmental Information. [access date]
                      </b>
                      <br />
                      If the file you are looking for is not yet online, please contact haz.info@noaa.gov to request it.
                    </p>
                  </span>
                </div>
                <CardTitle tag="h2">{`Marigrams - ${marigrams.size} Results Found`}</CardTitle>

                <MarigramDataGrid
                  marigrams={marigrams}
                  dataManager={dataManager}
                  sort={sort}
                  visibleColumns={visibleColumns}
                  toggleColumns={this.handleToggleColumns}
                  searchParams={JSON.stringify(sp)}
                  deleting={deleting}
                  deleteMarigram={deleteMarigram}
                  onDeleteCloseModal={() => searchMarigrams({ queryParameters, history })}
                />

              </CardBody>
            </Card>
          </div>
        </div>

      </div>
    );
  }
}

MarigramContainerUnwrapped.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  marigrams: ImmutablePropTypes.list.isRequired,
  searchMarigrams: PropTypes.func.isRequired,
  clearMarigramSearch: PropTypes.func.isRequired,
  deleteMarigram: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  clearRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  clearMarigramData: PropTypes.func.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  getCountries: PropTypes.func.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  getLocations: PropTypes.func.isRequired,
  states: ImmutablePropTypes.list.isRequired,
  getStates: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['marigramSearchPage', 'fetched']),
    state.getIn(['marigramDataPage', 'fetchedCountries']),
    state.getIn(['marigramDataPage', 'fetchedStates']),
    state.getIn(['marigramDataPage', 'fetchedLocations']),
  ].every(v => v),
  deleting: state.getIn(['marigramDataPage', 'deleting']),
  marigrams: state.getIn(['marigramSearchPage', 'marigrams']),
  searchRedirect: state.getIn(['marigramSearchPage', 'searchRedirect']),
  countries: state.getIn(['marigramDataPage', 'countries']),
  locations: state.getIn(['marigramDataPage', 'locations']),
  states: state.getIn(['marigramDataPage', 'states']),
  sort: state.getIn(['marigramSearchPage', 'sort']),
  visibleColumns: state.getIn(['marigramDataPage', 'visibleColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchMarigrams: searchMarigramsAc,
  clearMarigramSearch: clearMarigramSearchAc,
  deleteMarigram: deleteMarigramAc,
  clearRedirect: clearRedirectAc,
  getCountries: getCountriesAc,
  getLocations: getLocationsAc,
  getStates: getStatesAc,
  clearMarigramData: clearMarigramDataAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
}, dispatch);


export const MarigramContainer = connect(mapStateToProps, mapDispatchToProps)(MarigramContainerUnwrapped);
